var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThreeLabel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.532,
    height: 45.773,
    viewBox: "0 0 46.532 45.773",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22507",
    "data-name": "Group 22507",
    transform: "translate(-314.923 -544.316)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21684",
    "data-name": "Group 21684",
    transform: "translate(314.923 544.316)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50767",
    "data-name": "Path 50767",
    d: "M340.006,550.951c6.273-.014,12.531-.15,18.8-.45l2.345-.123c5.059.273,9.791-4.214,9.231-9.218-.518-7.036-1-14.1-1.309-21.149a7.03,7.03,0,0,0-6.845-7.582q-9.409,0-18.8-.436l-2.345-.123a7.867,7.867,0,0,0-9.218,7.05c-.464,6.272-.886,12.531-1.2,18.8-.027,1.555-.232,3.164-.109,4.663a9.574,9.574,0,0,0,9.45,8.563Zm0,0a10.183,10.183,0,0,1-9.954-8.5c-.218-1.623-.191-3.15-.286-4.732-.314-6.272-.736-12.531-1.2-18.8a11.809,11.809,0,0,1,4.527-9.913,13.11,13.11,0,0,1,8.018-2.618l2.345-.123q9.409-.45,18.8-.436A12.923,12.923,0,0,1,375,520l-.109,2.345c-.314,6.272-.736,12.531-1.2,18.8a11.542,11.542,0,0,1-1.6,5.127,11.126,11.126,0,0,1-10.909,5.236l-2.345-.123c-6.3-.273-12.559-.423-18.831-.436Z",
    transform: "translate(-328.544 -505.829)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_3",
    "data-name": 3,
    transform: "translate(330.392 577.192)",
    fill: "#fff",
    fontSize: 25,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "3")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeLabel);
export default __webpack_public_path__ + "static/media/three_label.c3b321f23139c16d20c56215586a9f31.svg";
export { ForwardRef as ReactComponent };